export enum ReportLinkOverviewWizardStep {
  PreviousRecipientsStep,
  RecipientsStep,
  ReviewStep,
  ShareReportStep,
}

export const REPORT_LINK_OVERVIEW_WIZARD_LABELS: Record<
  ReportLinkOverviewWizardStep,
  string
> = {
  [ReportLinkOverviewWizardStep.PreviousRecipientsStep]: "Previous recipients",
  [ReportLinkOverviewWizardStep.RecipientsStep]: "Recipients",
  [ReportLinkOverviewWizardStep.ReviewStep]: "Review",
  [ReportLinkOverviewWizardStep.ShareReportStep]: "Send link",
};
